import { SponsorType } from './sponsor-type.enum';

export interface SponsorTypeOption {
  value: SponsorType;
  label: string;
}

export const SPONSOR_TYPE_OPTIONS: SponsorTypeOption[] = [
  { value: SponsorType.HoleSponsor, label: 'Hole Sponsor' },
  { value: SponsorType.CartSponsor, label: 'Cart Sponsor' },
  { value: SponsorType.Donation, label: 'Donation' },
  { value: SponsorType.Team, label: 'Team' },
  { value: SponsorType.Other, label: 'Other' }
];

export function getSponsorTypeLabel(type: SponsorType | number | null | undefined): string {
  const match = SPONSOR_TYPE_OPTIONS.find((o) => o.value === type);
  return match?.label ?? '—';
}
